import PageHeader from 'components/PageHeader.tsx';
import PaddedLayout from 'layout/MainLayout/PaddedLayout.tsx';
import { FileUploader } from 'react-drag-drop-files';
import { useUploadBankTransfersMutation } from 'store/api/bank-transfers.ts';
import { errorAlert, infoAlert } from 'utils/alert';
import { t } from 'utils/getTranslations.ts';
import BankTransfersTable from './BankTransfersTable.tsx';
import BankTransferUploadBox from './BankTransferUploadBox.tsx';

const BankTransfersPage = () => {
    const [uploadBankTransfers, { isLoading }] = useUploadBankTransfersMutation();

    const handleChange = async (files: FileList) => {
        try {
            const summary = await uploadBankTransfers(files).unwrap();
            infoAlert(
                t('bank-transfers.uploaded-summary', {
                    savedCount: '' + summary.savedCount,
                    excludedDuplicateCount: '' + summary.excludedDuplicateCount,
                })
            );
        } catch {
            errorAlert(t('bank-transfers.upload-bank-transfers-error'));
        }
    };

    // `overflow-hidden` on the padded layout is load-bearing, not cosmetic: it is a flex item of
    // the scrolling main content column, and a flex item's automatic minimum size is its CONTENT,
    // so it refuses to shrink and the whole page scrolls instead. Any non-visible overflow drops
    // that minimum to 0, letting it shrink to the space available — which is what gives the inner
    // column, and the table's `height: 100%` frame, a definite height to resolve against. Without
    // it the frame hugs its rows, the header has no scrollport to pin to, and row windowing never
    // engages.
    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col">
                <PageHeader hostsList titleId={'bank-transfers.bank-transfers'} showBreadcrumb />
                {isLoading ? (
                    <BankTransferUploadBox isLoading />
                ) : (
                    <FileUploader
                        multiple={true}
                        handleChange={handleChange}
                        name="files"
                        types={['xml']}
                        dropMessageStyle={{ display: 'none' }}
                        onTypeError={() => errorAlert(t('bank-transfers.only-xml'))}
                    >
                        <BankTransferUploadBox isLoading={false} />
                    </FileUploader>
                )}
                <BankTransfersTable />
            </div>
        </PaddedLayout>
    );
};

export default BankTransfersPage;
